export default __webpack_public_path__ + "static/media/minimize.f75edb19.svg";